import { Pipe, PipeTransform } from '@angular/core';
import { I18nTranslator } from '../i18n/translate';
import { ARConsoleType } from '../models/agrorendement-common-lists.model';

@Pipe({
  name: 'consoleTypeLabel',
  standalone: true,
})
export class ConsoleTypeLabelPipe implements PipeTransform {
  constructor(private i18nTranslator: I18nTranslator) {}

  transform(consoleType: ARConsoleType, args: any): any {
    if (consoleType.label) {
      return consoleType.label;
    }

    if (consoleType.code === 'OTHER') {
      return this.i18nTranslator.translate('ar.edit.vra.console.marque.other');
    }

    // ne devrait pas arriver
    return '';
  }
}
